import TabContentPanel from './TabContentPanel';

export { TabContentPanel };
export default TabContentPanel;
